/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Pagination, Select, SelectItem, Spinner, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, Tooltip } from '@nextui-org/react';
import { IconSearch, } from '@tabler/icons-react';
import toast from 'react-hot-toast';
//import moment from 'moment';
import { Constants } from '../../../../utils';
import { TeacherAttendeceService, TeacherGeneralService } from '../../../../services';
import { useSelector } from 'react-redux';
import { generateAttendanceByLapsePDF, generateAttendanceBySubjectPDF } from './generate-pdf';
import PaidAction from '../../../../components/paid-action';



const MODAL_ACTION = {
  NONE: 0,
  SELECT_LAPSE: 1,
}

const Assistance = () => {
  const navigate = useNavigate();
  const [modal, setModal] = useState(MODAL_ACTION.NONE);
  const { canResetFilter, data, filterBy, goToPage, isLoading, pagination, reload, grades, lapses, sections, downloadByLapse, downloadBySubject, schoolYears } = useFetchTable();

  const openModal = (action) => {
    setModal(action);
  }

  const onCloseModal = () => {
    setModal(MODAL_ACTION.NONE);
  }

  const selectLapse = async (lapse) => {
    const res = await downloadByLapse(lapse);
    if (!res) return;
    generateAttendanceByLapsePDF(res)
  }

  const selectSubject = async (subject) => {
    const res = await downloadBySubject(subject);
    if (!res) return;
    generateAttendanceBySubjectPDF(res)
  }

  return (
    <div>

      <Modal
        size="sm"
        isOpen={modal === MODAL_ACTION.SELECT_LAPSE}
        onClose={onCloseModal}
        backdrop="blur"
        scrollBehavior="outside"
      >
        <ModalContent>
          {(onClose) => {
            return (
              <ModalFilter
                onSelectLapse={selectLapse}
                lapses={lapses}
                onClose={onClose}
              />
            )
          }}
        </ModalContent>
      </Modal>

      {isLoading && (
        <div className="w-screen h-screen fixed inset-0 z-[70] flex justify-center items-center bg-white/30">
          <Spinner />
        </div>
      )}

      <Filters
        canResetFilter={canResetFilter}
        filterBy={filterBy}
        resetFilter={() => reload()}
        grades={grades}
        sections={sections}
        lapses={lapses}
        schoolYears={schoolYears}
      />

      <Table
        aria-label="Evaluaciones"
        color="primary"
        topContentPlacement="inside"
        topContent={
          <div className="flex items-center justify-between gap-4">
            <div className=" flex flex-row justify-between items-center gap-4">
              <h3 className="text-xl font-medium">Registro de asistencia</h3>
            </div>
            <PaidAction>
              <Button
                className="bg-green text-white"
                onPress={() => openModal(MODAL_ACTION.SELECT_LAPSE)}
              >
                Descargar
              </Button>
            </PaidAction>
          </div>
        }
      >
        <TableHeader>
          <TableColumn>Nombre de la materia</TableColumn>
          <TableColumn>Grado</TableColumn>
          <TableColumn>Código</TableColumn>
          <TableColumn>Registo de asistencia</TableColumn>
          <TableColumn align="end" />
        </TableHeader>
        <TableBody items={data} emptyContent="No hay resultados">
          {(item) => {
            return (
              <TableRow key={item.id}>
                <TableCell>{item.name}</TableCell>
                <TableCell>{item?.school_grade?.name}</TableCell>
                <TableCell>{item?.code}</TableCell>
                <TableCell>
                  <span
                    className="cursor-pointer font-semibold text-sm text-secondary"
                    onClick={() => navigate('/assistance/create', { state: item })}
                  >
                    Ver
                  </span>
                </TableCell>
                <TableCell align="right">
                  <PaidAction>
                    <Button
                      className="bg-white text-xs border-1 border-secondary text-secondary"
                      onPress={() => selectSubject(item?.id)}
                    >
                      Descargar
                    </Button>
                  </PaidAction>
                </TableCell>
              </TableRow>
            )
          }}
        </TableBody>
      </Table>

      <div className="flex w-full justify-center mt-4">
        <Pagination
          showControls
          variant="bordered"
          page={pagination.page}
          total={pagination.pages}
          onChange={goToPage}
        />
      </div>
    </div>
  );
}

const ModalFilter = ({ onSelectLapse, lapses, onClose }) => {

  const [currentLapse, setCurrentLapse] = useState(null);

  return (
    <>
      <ModalHeader className="flex flex-col gap-1">Seleccione el lapso a descargar</ModalHeader>
      <ModalBody>
        <Select
          label="Lapso"
          labelPlacement="outside"
          placeholder=" "
          variant="bordered"
          radius="sm"
          classNames={{ label: 'font-semibold' }}
          disallowEmptySelection={true}
          selectedKeys={!!currentLapse ? [currentLapse] : []}
          onSelectionChange={v => setCurrentLapse(v.currentKey)}
        >
          {lapses.map((item) => (
            <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
          ))}
        </Select>
      </ModalBody>
      <ModalFooter>
        <Button variant="light" onPress={onClose}>Cancelar</Button>
        <Button className='bg-green text-white' onPress={() => onSelectLapse(currentLapse)}>Descargar</Button>
      </ModalFooter>
    </>
  )
}

const Filters = ({ canResetFilter, filterBy, resetFilter, grades, sections, lapses, schoolYears }) => {
  const initialFilter = {
    search: '',
    school_grade_id: '',
    school_section_id: '',
    school_lapse_id: '',
    school_year_id: '',
  };
  const [form, setForm] = useState(initialFilter);

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
    filterBy(value, target);
  }

  return (
    <section className="flex mt-10 md:mt-0 flex-col md:flex-row md:items-center gap-5">
      <div className='mb-4 grid sm:flex grid-cols-2 lg:flex-row items-end gap-4'>
        <Input
          label="Nombre de la materia"
          labelPlacement='outside'
          placeholder="Escribir"
          className='w-[15rem]'
          startContent={<IconSearch />}
          variant="bordered"
          radius="sm"
          value={form.search}
          onValueChange={v => onChange(v, 'search')}
        />

        <Select
          label="Año escolar"
          labelPlacement="outside"
          placeholder=" "
          variant="bordered"
          className='w-[15rem]'
          radius="sm"
          classNames={{ label: 'font-semibold' }}
          disallowEmptySelection={true}
          selectedKeys={!!form.school_year_id ? [form.school_year_id] : []}
          onSelectionChange={v => onChange(v.currentKey, 'school_year_id')}
        >
          {schoolYears.map((item) => (
            <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
          ))}
        </Select>

        <Select
          label="Grado"
          labelPlacement="outside"
          placeholder=" "
          variant="bordered"
          className='w-[15rem]'
          radius="sm"
          classNames={{ label: 'font-semibold' }}
          disallowEmptySelection={true}
          selectedKeys={!!form.school_grade_id ? [form.school_grade_id] : []}
          onSelectionChange={v => onChange(v.currentKey, 'school_grade_id')}
        >
          {grades.map((item) => (
            <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
          ))}
        </Select>
      </div>

      {canResetFilter && (
        <Button
          variant="light"
          className="text-primaryDark"
          onClick={() => {
            setForm(initialFilter);
            resetFilter();
          }}
        >
          Limpiar filtros
        </Button>
      )}
    </section>
  )
}

const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    search: '',
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };

  const user = useSelector(state => state.user);
  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);
  const [lapses, setLapses] = useState([]);
  const [grades, setGrades] = useState([]);
  const [schoolYears, setSchoolYears] = useState([]);
  const [sections, setSections] = useState([]);

  const debounceTime = 500;
  const debounce = useRef();

  const toSelect = (items) => items.map(x => ({ ...x, value: String(x.id), label: x.name }));

  const fetchData = async () => {
    try {
      setData([]);
      if (!canFetch) return;
      setCanFetch(false);
      const response = await TeacherGeneralService.generals.getSubjects({ ...filters, professor_id: user.id })
      const { data, ...rest } = response;
      setData(data);
      setPagination(rest);
      setCanFetch(true);
    } catch (error) {
      setData([]);
      onError(String(error));
    }
  }

  const getCurrentPagination = () => {
    let pag;
    setPagination(s => {
      pag = s;
      return s;
    });
    return pag;
  }

  const getSelects = async () => {
    try {
      const selects = await TeacherAttendeceService.attendence.getSelects({ professor_id: user.id });
      setGrades(toSelect(selects.grades));
      setLapses(toSelect(selects.lapses));
      setSections(toSelect(selects.sections));
      setSchoolYears(toSelect(selects.school_years));
      setCanFetch(true)

    } catch (error) {
      setData([]);
      onError(String(error));
    }
  }

  const canResetFilter = () => {
    const { page, perPage, ...initial } = initialFilters;
    const { page: _, perPage: __, ...current } = filters;
    const initFilter = JSON.stringify(initial);
    const currFilter = JSON.stringify(current);
    return initFilter !== currFilter;
  }

  const onError = (msg) => toast.error(msg);

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    else fetchData();
  }

  const goToPage = (page) => {
    const pagination = getCurrentPagination();
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
    }
  }

  const changePerPage = (perPage) => {
    setCanFetch(true);
    setFilters({ ...filters, perPage });
  }

  const filterBy = (value, target) => {
    if (debounce.current) clearTimeout(debounce.current);
    debounce.current = setTimeout(() => {
      setCanFetch(true);
      setFilters({ ...filters, page: 1, [target]: value });
    }, debounceTime);
  }

  const downloadByLapse = async (lapseId) => {
    try {
      const response = await TeacherAttendeceService.attendence.generateReportByLapse({ professor_id: user.id, school_lapse_id: +lapseId });
      return response;
    } catch (error) {
      toast.error(String(error) || "Ocurrió un error inesperado");
    }
  }

  const downloadBySubject = async (subjectId) => {
    try {
      const response = await TeacherAttendeceService.attendence.generateReportBySubject({ professor_id: user.id, subject_id: +subjectId });
      return response;
    } catch (error) {
      toast.error(String(error) || "Ocurrió un error inesperado");
    }
  }


  useEffect(() => {
    fetchData();
  }, [filters]);

  useEffect(() => {
    getSelects()
  }, [])

  return {
    canResetFilter: canResetFilter(),
    changePerPage,
    data,
    filterBy,
    filters,
    goToPage,
    isLoading: !canFetch,
    pagination,
    reload,
    lapses: filters.school_year_id ? lapses.filter(x => x.school_year_id === +filters.school_year_id) : lapses,
    grades: grades.filter(x => x.school_year_id === +filters.school_year_id),
    schoolYears,
    sections,
    downloadByLapse,
    downloadBySubject
  }
}

export default Assistance;
